import { IInputTreeProps, InputTree } from "../../../../../components/input";
import useDepartmentTree from "../hooks/use-department-tree";

const SelectDepartmentTree = (props: IInputTreeProps) => {
  const {
    data: departmentTree,
    isLoading: isLoadingDepartmentTree,
    isFetching: isFetchingDepartmentTree,
  } = useDepartmentTree();

  const loading = isLoadingDepartmentTree || isFetchingDepartmentTree;

  return (
    <InputTree
      {...props}
      isDisabled={loading || props.isDisabled}
      placeholder={props.placeholder || "* Chọn cơ quan/đơn vị"}
      asyncData={{
        response: departmentTree,
        pathTitle: "Dep_Name",
        pathKey: (item: any) => `${item.Dep_ID}|${item.Dep_Name}`,
        pathChildren: "ChildDepartment",
      }}
      treeProps={{
        ...props.treeProps,
        showSearch: true,
        filterTreeNode: (inputValue, node) => {
          const searchValue = inputValue.toLowerCase();
          const nodeTitle = (node?.title as string)?.toLowerCase() || "";
          return nodeTitle.includes(searchValue);
        },
        searchValue: props.treeProps?.searchValue,
      }}
    />
  );
};

export default SelectDepartmentTree;
